<div [class]="'keyboard' + keyboardIndex">
	<!-- <div class="predictive-column" *ngIf="filteredSuggestions != null && filteredSuggestions.length > 0">
  <div *ngFor="let suggestion of filteredSuggestions" class="word t4" (click)="selectSuggestedWord(suggestion)">{{suggestion}},</div>
	</div> -->
	<input hidden (input)="onInputChange($event)" class="input" [(ngModel)]="value" />
	<div class="simple-keyboard"></div>
</div>
